import { OFFER_STATUS } from "../constants/offerConstants"

export const getOfferStatusAdapter = (status: string) => {
    return OFFER_STATUS.hasOwnProperty(status) ? OFFER_STATUS[status] : 'NA'
}